import React, { useCallback } from "react";
import { DialogTitle, Tooltip } from "@mui/material";
import ChevronLeftIcon from "@mui/icons-material/ChevronLeft";
import { useSelector } from "react-redux";

import ChangeStatus from "./../components/ChangeStatus";
import ChangeTodoStatus from "../../../../../components/ToDo/ChangeTodoStatus";
import AttachFile from "./../components/changeBoard/attachFile/AttachFile";
import ChangeBoard from "./../components/changeBoard/ChangeBoard";
import DeleteCard from "../../Kanban/DeleteCard";
import DependsOnDropdown from "./../sidebar/components/dependsOnDropdown";
import mobileArrow from "../../../../../styles/svg/mobileArrow.svg";
import { TooltipName } from "../../../../../utils/Enums";
import { useCustomSearchParams } from "../../../../../hooks/useCustomSearchParams";
import { useNavigate } from "react-router-dom";
import { useSearchParams } from "react-router-dom";
import { useSetMultipleParams } from "../../../../../hooks/useSetMultipleParams";
import { useLocation } from "react-router-dom";
import MoveQuickToRegularTask from "./MoveQuickToRegularTask";

const DialogHeader = ({
  cardDetail,
  cardId,
  boardId,
  isMobile,
  isBetween700And900,
  card,
  board_permission,
  conditionCheck,
  accessForDeleteCard,
  accessForEditCard,
  checkIsOwnerOrAdmin,
  handleClose,
  setShowDetails,
  // updateSearchParams
}) => {
  const [searchParams, setSearchParams] = useSearchParams();
  const [setMultipleSearchParams] = useSetMultipleParams();
  const location = useLocation();
  const navigate = useNavigate();
  const isSubTask = cardDetail?.card_has_subtask;
  const [data, updateSearchParams, removeSearchParams] = useCustomSearchParams();
  const currentUser = useSelector((state) => state.users.logInUser);

  const BoardId = cardDetail?.board_id;
  const parentCardId = cardDetail?.parent_card_id;
  const boardKey = card.data.data.responseData.board.key;
  const handleParentOpenCardDetail = useCallback(
    (BoardId, parentCardId) => {
      setMultipleSearchParams([
        { name: "brd_id", value: BoardId },
        { name: "card_id", value: parentCardId },
      ]);
    },
    [setMultipleSearchParams]
  );

  const handleParentClick = (event) => {
    const route = location.pathname.split("/")[1];
    if (route == "board" || route == "feeds") {
      const isModifierPressed = event.metaKey || event.ctrlKey || event.shiftKey;
      const params = new URLSearchParams(searchParams.toString());
      const url = `/${route}/${boardKey}/${boardKey}-${parentCardId}?${params.toString()}`;
      if (isModifierPressed) {
        window.open(url, "_blank");
        event.stopPropagation();
        return;
      }
      navigate(url);
    } else {
      handleParentOpenCardDetail(BoardId, parentCardId);
    }
  };

  return (
    <DialogTitle
      sx={{
        m: 0,
        p: 2,
        alignItems: "center",
        backgroundColor: "rgba(242, 246, 254, 1)",
        borderBottom: "1px solid rgba(27, 62, 97, 0.16)",
      }}
      id="customized-dialog-title"
      className={`d-flex header ${cardDetail?.parent_card_id && "parent-card-detail"
        }`}
    >
      {cardDetail?.parent_card_id && (
        <Tooltip title={TooltipName.OPEN_PARENT_TASK_DETAIL}>
          <span
            className="related_time parent-title-id mb-2 cursor-pointer"
            onClick={
              (event) =>
                handleParentClick(event)
            }
          >
            {`${cardDetail?.board?.key} - ${cardDetail?.parent_card_id}`}
          </span>
        </Tooltip>
      )}
      <div className="modal-header-container">
        <div
          className={`${isMobile ? (isBetween700And900 ? "ipad-" : "mobile-") : ""
            }modal-header-inner-container`}
        >
          <div
            className={
              isMobile ? "mobile-left-heading" : "d-flex align-items-center"
            }
          >
            {isMobile && (
              <ChevronLeftIcon
                onClick={handleClose}
                className="board-owner-avtar-click"
                sx={{ opacity: "1 !important", pointerEvents: "auto" }}
              />
            )}
            <div className={isMobile ? "" : "project-name d-flex"}>
              <div>
                <div
                  className={isMobile ? "mobile-project-name" : "project-name"}
                >
                  {`${cardDetail?.board?.key}-${cardId}`}
                </div>
              </div>
            </div>
            {card && (
              <div className={cardDetail?.parent_card_id ? "pt-10" : ""}>
                {cardDetail?.workflow_step_id ? (
                  <ChangeStatus
                    currentStatusId={cardDetail.workflow_step_id}
                    cardId={cardId}
                    checkCondition={conditionCheck}
                    card={card}
                    boardPermission={board_permission}
                    currentUser={currentUser}
                  />
                ) : (
                  <ChangeTodoStatus
                    todoStatus={cardDetail?.todo_column}
                    cardId={cardId}
                    isBoardAdmins={board_permission?.is_admin}
                    owner_user_id={cardDetail?.board?.owner_user_id}
                    assigned_to_user_id={cardDetail?.assigned_to_user_id}
                    reporter={cardDetail?.reporter}
                    board_id={cardDetail?.board_id}
                    boardPermission={board_permission}
                  />
                )}
              </div>
            )}
          </div>
          {isMobile && accessForEditCard && (
            <div className="mr-2">
              <AttachFile cardId={cardId} isMobile={true} />
            </div>
          )}
        </div>
        {!isMobile && (
          <div className="d-flex right-heading mr-24">
            {cardDetail?.is_todo && (checkIsOwnerOrAdmin || conditionCheck) && <MoveQuickToRegularTask  cardDetail={cardDetail} cardId={cardId}/>}
            {card &&
              cardDetail &&
              !cardDetail?.card_has_subtask &&
              accessForEditCard && (
                <DependsOnDropdown cardId={Number(cardId)} card={card} />
              )}
            {card &&
              !cardDetail?.card_has_subtask &&
              !cardDetail?.parent_card_id &&
              checkIsOwnerOrAdmin && (
                <ChangeBoard cardId={cardId} card={card} />
              )}
            {accessForEditCard && (
              <div className="header-attach-btn ">
                <AttachFile cardId={cardId} />
              </div>
            )}
            {((accessForDeleteCard && !isSubTask) || (board_permission?.can_delete_card && cardDetail?.assigned_to_user_id===currentUser?.user_id) || cardDetail?.reporter?.id===currentUser?.user_id) && (
              <DeleteCard
                cardId={cardId}
                boardId={boardId}
                setShowDetails={setShowDetails}
                DeleteIconStyle="cardDetail-delete-icon"
              />
            )}
          </div>
        )}
      </div>
    </DialogTitle>
  );
};

const isChangeDialogHeader = (prevProps, nextProps) => {
  return (
    prevProps.cardDetail?.board?.key === nextProps.cardDetail?.board?.key
    &&
    prevProps.cardDetail?.parent_card_id === nextProps.cardDetail?.parent_card_id
    &&
    prevProps.cardDetail?.workflow_step_id === nextProps.cardDetail?.workflow_step_id
    &&
    prevProps.cardDetail?.todo_column === nextProps.cardDetail?.todo_column
    &&
    prevProps.cardId === nextProps.cardId
    &&
    prevProps.boardId === nextProps.boardId
    &&
    prevProps.isMobile === nextProps.isMobile
    &&
    prevProps.isBetween700And900 === nextProps.isBetween700And900
    &&
    prevProps.card === nextProps.card
    &&
    prevProps.board_permission === nextProps.board_permission
    &&
    prevProps.conditionCheck === nextProps.conditionCheck
    &&
    prevProps.accessForDeleteCard === nextProps.accessForDeleteCard
    &&
    prevProps.accessForEditCard === nextProps.accessForEditCard
    &&
    prevProps.checkIsOwnerOrAdmin === nextProps.checkIsOwnerOrAdmin
    &&
    prevProps.handleClose === nextProps.handleClose
    &&
    prevProps.setShowDetails === nextProps.setShowDetails
  )
}

export default React.memo(DialogHeader, isChangeDialogHeader);
